export type { FutureEntriesIndicatorTranslations } from "./future-entries-indicator-pt-br";

export { FUTURE_ENTRIES_INDICATOR_PT_BR } from "./future-entries-indicator-pt-br";
export { FUTURE_ENTRIES_INDICATOR_FR_FR } from "./future-entries-indicator-fr-fr";
export { FUTURE_ENTRIES_INDICATOR_ES_MX } from "./future-entries-indicator-es-mx";
export { FUTURE_ENTRIES_INDICATOR_EN_US } from "./future-entries-indicator-en-us";
